<p-dialog [(visible)]="show" [modal]="true" [position]="'center'" [closeOnEscape]="false" [closable]="false" appendTo="body">
  <ng-template pTemplate="header">
    <div class="grid" style="width: 100%">
      <div class="col-3">
        <div class="flex justify-content-start">
          <button pButton label="Send" icon="fa fa-paper-plane" [raised]="true" (click)="onSendClick()"></button>
        </div>
      </div>
      <div class="col-6"></div>
      <div class="col-3">
        <div class="flex justify-content-end w-100">
          <button pButton label="Discard" icon="fa fa-trash" [raised]="true" (click)="onDiscardClick()"></button>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="grid">
    <div class="col-12">
      <app-address-book labelText="TO" (addressListChange)="onToListChange($event)" [addressList]="toList"></app-address-book>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <app-address-book labelText="CC" (addressListChange)="onCcListChange($event)" [addressList]="ccList"></app-address-book>
    </div>
  </div>
  <div class="grid w-full mt-2">
    <div class="col-12">
      <p-floatlabel variant="on">
        <input type="text" id="subject" pInputText [(ngModel)]="subject" style="width: 100%" />
        <label for="subject">Subject</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid w-full mt-2">
    <div class="col-12">
      <p-floatlabel variant="on">
        <p-editor id="message" [(ngModel)]="message" [style]="{ height: '20rem', width: '100%' }" data-testid="messageEditor"> </p-editor>
      </p-floatlabel>
    </div>
  </div>
</p-dialog>
